<script lang="ts">
  import { pageHrefs } from '$lib/constants/breadCrumbConstants'
  import type { LandingPage } from '$lib/types/ServicePageTypes'
  import { _ } from 'svelte-i18n'
  import SEO from '$lib/components/seo/SEO.svelte'
  import Helse from '$lib/components/icons/largeIcons/Helse.svelte'
  import H4 from '$lib/components/typography/H4.svelte'
  import H1 from '$lib/components/typography/H1.svelte'
  import ButtonFlexPanel from '../(tjenesteSlots)/(panels)/ButtonFlexPanel.svelte'
  import ServiceLinkPanel from '$lib/components/serviceLinkPanel/ServiceLinkPanel.svelte'
  import { CtaDoubleSection, CtaSection } from '$lib/components/cta'
  import GeneralSectionWrapper from '$lib/wrappers/GeneralSectionWrapper.svelte'
  import Resources from '$lib/components/landingPage/Resources.svelte'
  import LandingPageFaqWrapper from '$lib/components/article/LandingPageFaqWrapper.svelte'

  export let data: LandingPage
  const { ctaSection1, ctaSection2, relevantFaqs, ingress, resources, title, seo, ctaSectionDouble } = data
</script>

<SEO title={seo?.metaTitle || title} description={seo?.metaDescription || ingress} />
<GeneralSectionWrapper class="bg-primary-50">
  <Helse />
  <H1 class="text-gray-800 pb-4">{title}</H1>
  {#if ingress}
    <H4 class="text-base-black pb-8">{ingress}</H4>
  {/if}
</GeneralSectionWrapper>
<GeneralSectionWrapper class="bg-base-white">
  <ButtonFlexPanel>
    <ServiceLinkPanel grow title={$_('helse.linkButtons.doctor')} href={pageHrefs.lege()} fitHeightToOuterDiv
      >{$_('helse.linkButtons.doctor')}</ServiceLinkPanel
    >
    <ServiceLinkPanel
      grow
      title={$_('helse.linkButtons.healthCenter')}
      href={pageHrefs.helsestasjon()}
      fitHeightToOuterDiv>{$_('helse.linkButtons.healthCenter')}</ServiceLinkPanel
    >
    <ServiceLinkPanel grow title={$_('helse.linkButtons.dentist')} href={pageHrefs.tannlege()} fitHeightToOuterDiv
      >{$_('helse.linkButtons.dentist')}</ServiceLinkPanel
    >
  </ButtonFlexPanel>
</GeneralSectionWrapper>
{#key ctaSectionDouble}
  <CtaDoubleSection {ctaSectionDouble} class="bg-base-white py-4 md:pb-8" />
{/key}
<CtaSection ctaSection={ctaSection1} />
<CtaSection ctaSection={ctaSection2} />
<Resources {resources} pageHref={pageHrefs.helseressurser()} />
<LandingPageFaqWrapper {relevantFaqs} />
